import {GeneralAction} from "../../../@types/actions";
import {SET_CLASSIC_SETTINGS} from "../../../constants/OddsConstants";
import {DoClassicSettingsObject} from "../../../@types/response";

export const SetClassicSettings = (settings: DoClassicSettingsObject): GeneralAction<DoClassicSettingsObject> => ({
    type: SET_CLASSIC_SETTINGS,
    payload: settings
});
